import { axios } from '../../../axios';

const filterProperties = async (filters) => {

    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
        if (value !== "" && value !== undefined) {
            params.append(key, value);
        }
    });

    try {
        const response = await axios.get(`/properties?${params.toString()}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching properties:", error);
    }
};


export { filterProperties }